import { ListingFilters } from "@/lib/fetch/listing";
import { Building, Car, DoorOpen, Home, Hotel, LampDesk } from "lucide-react";
import { useTranslations } from "next-intl";
import { twMerge } from "tailwind-merge";
import FilterWrapper from "./FilterWrapper";
import React from "react";

type Props = {
  value: ListingFilters["type"];
  setValue: (value: ListingFilters["type"]) => void;
};

const FilterPropertyType: React.FC<Props> = ({ setValue, value }) => {
  const t = useTranslations("listing");

  const options = [
    {
      name: "HOUSE",
      icon: <Home className="size-4" />,
    },
    {
      name: "APARTMENT",
      icon: <Building className="size-4" />,
    },
    {
      name: "PARKING",
      icon: <Car className="size-4" />,
    },
    {
      name: "ROOM",
      icon: <DoorOpen className="size-4" />,
    },
    {
      name: "STUDIO",
      icon: <LampDesk className="size-4" />,
    },
  ] as const;

  return (
    <FilterWrapper
      title={t("attribute_title.PROPERTY_TYPE")}
      icon={<Hotel className="size-5 text-primary" />}
    >
      <div className="grid grid-cols-3 gap-x-2 gap-y-2">
        {options.map((option) => (
          <button
            key={option.name}
            type="button"
            onClick={() => {
              if (!value) {
                setValue([option.name]);
              } else {
                if (value.includes(option.name)) {
                  const newValue = value.filter((v) => v !== option.name);
                  setValue(newValue.length > 0 ? newValue : undefined);
                } else {
                  setValue([...value, option.name]);
                }
              }
            }}
            className={twMerge(
              "flex flex-col py-3 gap-2 rounded-2xl items-center justify-center border-2 transition-colors",
              value?.includes(option.name) &&
                "border-primary outline  outline-secondary outline-offset-1 outline-2"
            )}
          >
            {option.icon}
            <span className="text-xs break-words overflow-wrap hyphens-auto px-1">
              {t(`attributes.PROPERTY_TYPE.${option.name}`)}
            </span>
          </button>
        ))}
      </div>
    </FilterWrapper>
  );
};

export default FilterPropertyType;
